import React from 'react';
import { NylasScheduling } from '@nylas/react';
import { Loading } from 'components/Loading';
import NotFound from 'pages/NotFound';
import './scheduler.scss';

const SchedulerReschedule = ({ bookingRef, error }) => {

  if (!bookingRef && !error) {
    return (
      <Loading />
    );
  }

  if (error) {
    return <NotFound />;
  }

  return (
    <>
      <div className="scheduler__header" />
      <NylasScheduling
        rescheduleBookingRef={bookingRef}
        enableUserFeedback={false}
        nylasBranding={false}
      />
    </>
  );
};

export default SchedulerReschedule;
